import React from 'react';
import { Modal } from '@vectord/components';

import { CreateSbatGroupLectureContentForm } from 'features/classCreation';

export default function CreateLectureContentModal({
  isOpen,
  title,
  contentType,
  handleClose,
  sbatGroup,
}) {
  return (
    <Modal
      isOpen={isOpen}
      size="large"
      title={title}
      unMountOnClose
      onClose={handleClose}
    >
      <CreateSbatGroupLectureContentForm
        contentType={contentType}
        label={title}
        onSuccess={handleClose}
        sbatGroup={sbatGroup}
      />
    </Modal>
  );
}
